import React from 'react';
import clsx from 'clsx';
import { Field } from 'formik';
import styles from '../filters.module.scss';

type SelectOption = {
  value: string | number;
  label?: string | number;
};

interface DateSelectProps {
  name: string;
  value: string;
  placeholder: string;
  options: SelectOption[];
  disabled?: boolean;
}

const DateSelect: React.FC<DateSelectProps> = ({ name, value, options, placeholder, disabled }) => {
  return (
    <div className={clsx('vc-formUnit', 'vc-formUnit--select', styles['vc-formUnit'], styles['vc-formUnit--select'])}>
      <Field
        as="select"
        name={name}
        aria-labelledby="label-year"
        className={'vc-inputText'}
        value={value}
        disabled={disabled}
      >
        <option
          value=""
          disabled
        >
          {placeholder}
        </option>

        {options.map(({ value: optValue, label }) => (
          <option
            key={optValue}
            value={optValue}
          >
            {label}
          </option>
        ))}
      </Field>
    </div>
  );
};

export default DateSelect;
